import { useState } from 'react';
import { InvoiceLineItemClient, InvoiceLineItemDTO, ApiResponse_string, SearchRequestDTO_InvoiceLineItemSearchRequestDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useInvoiceLineItemApi = () => {
    const apiClient = new InvoiceLineItemClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: InvoiceLineItemDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createInvoiceLineItem(data);
        } catch (err: any) {
            setError(err.message || 'Error creating InvoiceLineItem');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: InvoiceLineItemDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateInvoiceLineItem(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating InvoiceLineItem');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getInvoiceLineItemById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching InvoiceLineItem');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchInvoiceLineItems(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching InvoiceLineItems');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteInvoiceLineItem(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting InvoiceLineItem');
        } finally {
            setIsLoading(false);
        }
    };

    const extract = async (
        filters: any
    ): Promise<ApiResponse_string> => {
        setIsLoading(true);
        try {
            return await apiClient.exportInvoiceLineItems(filters);
        } catch (err: unknown) {
            handleHookError(err, 'Error exporting InvoiceLineItems', setError);
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, extract, remove, isLoading, error };
};